import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { IVesselVoyage, IVesselVoyageCriteria } from '../vessel-voyage-interface';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/shared/constants/message';

@Component({
    selector: 'app-vessel-voyage-view',
    templateUrl: './vessel-voyage-view.component.html',
    styleUrls: ['./vessel-voyage-view.component.less'],
    standalone: false
})
export class VesselVoyageViewComponent implements OnInit, AfterViewInit, OnDestroy {

  vesselVoyageForm: FormGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizeOptions: Array<number> = this.utilityService.getPageSizeOptions();
  totalVesselVoyage: number;
  vesselVoyageColumns = ['vesselName', 'voyageNo', 'action'];
  criteria: IVesselVoyageCriteria = {};
  addPermission: boolean = false;
  editPermission: boolean = false;
  viewPermission: boolean = false;
  dataSource = new MatTableDataSource<IVesselVoyage>();
  vesselList:any;
	subscription = new Subscription();

  constructor(private formBuilder: FormBuilder, private service: DataService, private utilityService: UtilityService,
              private permissionService: PermissionService, private activatedRoute: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.setVesselNameValueChangeEvent();
    this.setVoyageNoValueChangeEvent();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.paginator?.page?.pipe(tap(() => this.getVesselVoyagesList())).subscribe();
    this.getVesselVoyagesList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initializeForm() {
    this.vesselVoyageForm = this.formBuilder.group({
      vesselId: [],
      voyageNo: []
    })
  }

  setVesselNameValueChangeEvent(){
    this.vesselId.valueChanges.subscribe(vesselName => {
       this.criteria.vesselName=vesselName;
       this.getVesselVoyagesList(true);
    });
  }

  setVoyageNoValueChangeEvent(){
    const sub = this.voyageNo.valueChanges.subscribe(voyageNo => {
       this.criteria['voyageNo.contains']=voyageNo;
       this.getVesselVoyagesList(true);
    });
    this.subscription.add(sub);
  }

  sortData(event){
    this.criteria.sort = [event.active, event.direction];
    this.getVesselVoyagesList(true);
  }

  openVesselVoyageForm(id?:number){
    if(id){
      this.editPermission ? this.router.navigate(['edit/'+id],{relativeTo:this.activatedRoute}) :
          this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
    } else {
      this.addPermission ? this.router.navigate(['add'],{relativeTo:this.activatedRoute}) : 
        this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
    }
 }

  getVesselVoyagesList(resetPageIndex: boolean =false){
    if (resetPageIndex) {
      this.paginator.pageIndex = 0;
    }
    this.criteria.page=this.paginator?.pageIndex;
    this.criteria.size=this.paginator?.pageSize;
    this.criteria.sort=this.criteria.sort?this.criteria.sort:['createdDate','desc'];
    if(this.viewPermission){
      this.service.get(Api.VESSEL_VOYAGE,this.criteria).subscribe(res => {
        if(res){
          if(res.contents.length==0){
            this.utilityService.notifier('No records Found','info');
          }
          this.dataSource=res.contents;
          this.totalVesselVoyage=res.totalRecords
          if (this.paginator.pageIndex >= Math.ceil(res.totalRecords / this.paginator.pageSize)) {
            this.paginator.pageIndex = 0;
          }
        } 
      });
    } else{
      this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
    }
  }

  public checkAllPermission(){
    const permissionCodes=[PermissionKey.VESSEL_VOYAGE_MODULE_ADD_PERMISSION,PermissionKey.VESSEL_VOYAGE_MODULE_EDIT_PERMISSION,PermissionKey.VESSEL_VOYAGE_MODULE_VIEW_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.VESSEL_VOYAGE_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_VOYAGE_MODULE_ADD_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_VOYAGE_MODULE_VIEW_PERMISSION})?.show?true:false; 
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_VOYAGE_MODULE_EDIT_PERMISSION})?.show?true:false; 
  }

  get vesselId(){ return this.vesselVoyageForm.get('vesselId'); }
  get voyageNo(){ return this.vesselVoyageForm.get('voyageNo'); }

}
